import * as S from './styles';

export type LabelSize = 1 | 2 | 3;
export type LabelProps = {
  $size: LabelSize;
  $obrigatorio: boolean;
  $highContrast: boolean;
  $tooltip?: string;
  $label: string;
};

export default function Label(props: LabelProps) {
  const { $obrigatorio, $label, $size, $highContrast } = props;
  const propsTexto = { $highContrast, $size };
  return (
    <S.Container>
      <S.Texto {...propsTexto}>{$label}</S.Texto>
      {!$obrigatorio ? (
        <S.TextoOpcional {...propsTexto}>opcional</S.TextoOpcional>
      ) : (
        <></>
      )}
    </S.Container>
  );
}
